// @ts-generator-hash: 6594d8d5cb7303b942c4ebfc9f464f0b06782eb0430527ff3c6fb0aa33a9d46c
// Generation date: 3/13/2026 9:27:57 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.ExternalUserRole
export enum ExternalUserRole {
  REVIEWER = 3,
  AE_DESIGNER = 4,
  PROJECT_MANAGER = 5,
}
